import filteredProducts from "../modules/filter/filteredProducts";
import initCustomForms from '../modules/initCustomForms';
import initPopups from '../modules/initPopups';
import scrollHidden from '../modules/scrollHidden';
import header from '../modules/header/index';
import addToCardEventInit from "../modules/addToCardEvent";
import checkout from '../modules/checkoutModule';

jQuery(function() {
    header();
    checkout();
    initCustomForms();
    initPopups();
    scrollHidden();

    const $dataContainer = $('.data-container');
    const title = $dataContainer.attr('data-title');
    const metaDescription = $dataContainer.attr('data-meta-description');

    filteredProducts({
        updateCatalogFilter: true,
        apiUrl: '/umbraco/api/products/GetPaginatedBrand',
        title,
        metaDescription
    });
    addToCardEventInit();
})
